module.exports = __webpack_public_path__ + "media/src/images/abouts/items/stores/aeon_cinema-40af7d5eea6b1c47e031250dd59cddda.jpg";